import './Ornament.css';

export type OrnamentKind = 'guitar' | 'notes' | 'leaves' | 'drum';

interface OrnamentProps {
  kind: OrnamentKind;
  /** Corner the silhouette sits in. */
  position?: 'left' | 'right';
  size?: number;
}

/**
 * Warm silhouettes from the player's own world — a guitar body, a couple of
 * notes, a sprig — used as texture in the corner of large cards.
 *
 * Rules (design/direction.md): one per card, never under text, never a
 * gradient blob. They are objects, not decoration for its own sake.
 */
export function Ornament({ kind, position = 'right', size = 140 }: OrnamentProps) {
  return (
    <div className={`ornament ornament--${position}`} aria-hidden="true" style={{ width: size }}>
      <svg viewBox="0 0 100 100" width={size} height={size}>
        {kind === 'guitar' && <GuitarShape />}
        {kind === 'notes' && <NotesShape />}
        {kind === 'leaves' && <LeavesShape />}
        {kind === 'drum' && <DrumShape />}
      </svg>
    </div>
  );
}

function GuitarShape() {
  return (
    <g>
      <path d="M38 96c-12 0-21-9-21-20 0-8 4-13 4-20s-3-10-3-17c0-10 8-18 19-18 8 0 12 4 17 4s9-4 17-4c10 0 18 8 18 18 0 7-3 10-3 17s4 12 4 20c0 11-9 20-21 20-9 0-13-5-15-5s-7 5-16 5z" />
      <circle className="ornament__hole" cx="52" cy="52" r="11" />
      <rect x="47" y="4" width="10" height="26" rx="3" />
      <rect x="43" y="0" width="18" height="8" rx="3" />
    </g>
  );
}

function NotesShape() {
  return (
    <g>
      <ellipse cx="26" cy="76" rx="15" ry="11" transform="rotate(-18 26 76)" />
      <rect x="37" y="16" width="7" height="58" rx="3" />
      <ellipse cx="68" cy="64" rx="15" ry="11" transform="rotate(-18 68 64)" />
      <rect x="79" y="6" width="7" height="56" rx="3" />
      <path d="M37 16c14-4 30-7 49-10v14c-19 3-35 6-49 10z" />
    </g>
  );
}

function LeavesShape() {
  return (
    <g>
      <path d="M50 98c0-30 0-50 0-70" strokeWidth="5" stroke="currentColor" fill="none" />
      <path d="M50 62c-18 2-30-8-30-24 16-2 28 8 30 24z" />
      <path d="M50 44c18 2 30-8 30-24-16-2-28 8-30 24z" />
      <path d="M50 84c-14 2-24-6-24-19 13-2 22 7 24 19z" />
    </g>
  );
}

function DrumShape() {
  return (
    <g>
      <rect x="14" y="44" width="72" height="34" rx="8" />
      <ellipse className="ornament__hole" cx="50" cy="44" rx="36" ry="12" />
      <rect x="18" y="8" width="6" height="34" rx="3" transform="rotate(-22 21 25)" />
      <rect x="76" y="8" width="6" height="34" rx="3" transform="rotate(22 79 25)" />
    </g>
  );
}
